import React, { useState, useEffect } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

const VideoPlayerSection = ({ submission, onAssetStatusChange }) => {
  const [isLandscape, setIsLandscape] = useState(true);
  const [assetError, setAssetError] = useState(false);
  const [posterLoaded, setPosterLoaded] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // console.log("submission: ", submission);

  useEffect(() => {
    // Attempt to load the poster image
    const img = new Image();
    img.src = `https://swayer.blob.core.windows.net/${submission.submissionSaleId}-pub/thumbnail_master.png`;
    img.onload = () => {
      setPosterLoaded(true);
      onAssetStatusChange(false); // Notify parent that assets are ready
    };
    img.onerror = () => {
      setAssetError(true);
      onAssetStatusChange(true); // Notify parent that assets are still processing
    };
  }, [submission, onAssetStatusChange]);

  const handleMetadataLoaded = (event) => {
    const videoElement = event.target;
    const { videoWidth, videoHeight } = videoElement;
    setIsLandscape(videoWidth >= videoHeight);
  };

  const handleVideoError = () => {
    setAssetError(true);
    onAssetStatusChange(true); // Notify parent that assets are still processing
  };

  const getVideoWidth = () => {
    if (isMobile && !isLandscape) {
      return "100%";
    } else if (isLandscape) {
      return "90%";
    } else {
      return "30%";
    }
  };

  return (
    <Box
      sx={{
        mb: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      {assetError ? (
        <Typography
          variant="body1"
          sx={{
            fontFamily: "basic-sans",
            color: "white",
            fontSize: "1.2rem",
          }}
        >
          Submission is being processed. Please check back soon for updates.
        </Typography>
      ) : (
        posterLoaded && (
          <video
            controls
            controlsList="nodownload"
            onContextMenu={(e) => e.preventDefault()}
            onLoadedMetadata={handleMetadataLoaded}
            onError={handleVideoError}
            poster={`https://swayer.blob.core.windows.net/${submission.submissionSaleId}-pub/thumbnail_master.png`}
            style={{
              width: getVideoWidth(),
              borderRadius: "25px",
              transition: "width 0.3s ease-in-out",
            }}
          >
            <source
              src={`https://swayer.blob.core.windows.net/${
                submission.submissionSaleId
              }-pub/${
                submission.challengeData && submission.challengeData.allowCrowdFunding
                  ? "_main.mp4"
                  : "preview.mp4"
              }`}
              type="video/mp4"
              onError={handleVideoError}
            />
            Your browser does not support the video tag.
          </video>
        )
      )}
    </Box>
  );
};

export default VideoPlayerSection;
